import React, { useState, useEffect, Suspense } from "react";
import usePaginationValuesWhere from "../hooks/usePaginationValuesWhere";
import useExceptionHandler from "hooks/useExceptionHandler";
import useMessage from "hooks/useMessage";
import { PerfilManager } from "managers";
import { GridView } from "components";
import Select from "react-select";
import IconButton from "components/IconButton/IconButton";
import ToolTip from "components/ToolTip/ToolTip";
import ListHeader from "components/PantallaList/Header/ListHeader";
import Exportar from "components/Exportar/Exportar";
import { Perfil } from "models/Perfil";
import { SvgComponent } from "components";
import { DEFAULT_PAGINATION_VALUES } from "utils";
import PerfilEdit from "views/PerfilEdit";
import SuspenseECF from "components/Suspense/SuspenseECF";

export default function PerfilList({
  showLoading,
  hideLoading,
  hideTitle,
  isActive,
}) {
  const [where, setWhere] = useState({});
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION_VALUES);
  const [list, setList] = useState([]);
  const [showCanvas, setShowCanvas] = useState(false);
  const [showExportar, setShowExportar] = useState(false);
  const [idSec, setIdSec] = useState(undefined);
  const [esClonar, setEsClonar] = useState(false);
  const { setPaginationValuesWhere } = usePaginationValuesWhere();
  const { handleException } = useExceptionHandler();
  const { cerrarAlertas } = useMessage();
  const ESTATUS_LIST = [{ value: "", label: "Todos" }, ...Perfil.ESTATUS_LIST];

  useEffect(() => {
    if (isActive) {
      buscar();
    }
    return () => {
      cerrarAlertas();
      hideLoading();
    };
  }, [where, isActive]);

  const buscar = () => {
    const whereWithPaginationValues = { ...where, ...pagination };
    PerfilManager.listado(whereWithPaginationValues)
      .then((res) => {
        setPaginationValuesWhere(res.Headers, pagination, setPagination);
        setList(res.Data);
      })
      .catch((error) => handleException(error))
      .finally(() => hideLoading());
  };

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => ({
      ...prevstate,
      IndiceDePagina: pageNumber - 1,
    }));
    setWhere({ ...where });
  };

  const handleClick = (params) => {
    if (params && params.Id) {
      setIdSec(params.Id);
      setEsClonar(params.Clonar === true);
    } else {
      setIdSec(undefined);
      setEsClonar(false);
    }
    setShowCanvas(true);
  };

  const updateList = () => {
    setWhere((prev) => ({ ...prev }));
  };

  return (
    <div>
      {showCanvas && (
        <Suspense fallback={<SuspenseECF />}>
          <PerfilEdit
            showCanvas={showCanvas}
            setShowCanvas={setShowCanvas}
            IdSec={idSec}
            esClonar={esClonar}
            showLoading={showLoading}
            hideLoading={hideLoading}
            updateList={updateList}
          />
        </Suspense>
      )}
      <Exportar
        PROPIEDADES_EXPORTAR={Perfil.PROPIEDADES_EXPORTAR}
        showExportar={showExportar}
        setShowExportar={setShowExportar}
        showLoading={showLoading}
        hideLoading={hideLoading}
        where={where}
        exportarCallBack={PerfilManager.exportarExcel}
      ></Exportar>

      <div style={{ paddingRight: "6px" }}>
        <ListHeader
          titulo={hideTitle ? "" : "Perfil"}
          crearNuevo={handleClick}
          exportar={() => setShowExportar(true)}
        />
      </div>
      <GridView
        pagination={pagination}
        setPagination={setPagination}
        allowPaging={pagination.EsPaginable}
        pageSize={pagination.CantidadPorPagina}
        pageIndex={pagination.IndiceDePagina}
        lastPageNumber={pagination.PaginasTotal}
        dataSource={list}
        onPageIndexChanging={onPageIndexChanging}
        where={where}
        setWhere={setWhere}
        height="70vh"
      >
        <GridView.Column
          bodyRenderer={(row) => (
            <div className="float-right">
              <IconButton onClick={() => handleClick({ Id: row.IdSec, Clonar: false })}>
                <ToolTip message="Editar">
                  <div>
                    <SvgComponent iconName="pencil" height="25px" width="25px" />
                  </div>
                </ToolTip>
              </IconButton>
              <IconButton onClick={() => handleClick({ Id: row.IdSec, Clonar: true })}>
                <ToolTip message="Clonar">
                  <div>
                    <SvgComponent iconName="copy" height="25px" width="25px" />
                  </div>
                </ToolTip>
              </IconButton>
            </div>
          )}
        />
        <GridView.Column
          headerText="Id"
          dataField="IdSec"
          sortExpression="IdSec"
        />
        <GridView.Column
          headerText="Nombre"
          dataField="Nombre"
          sortExpression="Nombre"
        />
        <GridView.Column
          headerText="Estatus"
          dataField="Estatus"
          sortExpression="Estatus"
          filterRenderer={() => (
            <Select
              className="react-select primary"
              options={ESTATUS_LIST}
              value={ESTATUS_LIST.filter(
                (option) =>
                  option.value ===
                  (where.Estatus ? where.Estatus : ESTATUS_LIST[0].value)
              )}
              name="Estatus"
              onChange={(e) => setWhere({ ...where, Estatus: e.value })}
            />
          )}
        />
      </GridView>
    </div>
  );
}
